module.exports = __webpack_public_path__ + "images/chart04Preview.png";